import Vue from "vue";
import Router from "vue-router";
import Orders from "./views/Orders.vue";
import Carts from "./views/Carts.vue";
import Campaigns from "./views/campaigns/Campaigns.vue";
import Notifications from "./views/Notifications.vue";
import CreateReferralCampaign from "./views/campaigns/CreateReferralCampaign.vue";
import CreateInfluencerCampaign from "./views/campaigns/CreateInfluencerCampaign.vue";
import Tasks from "./views/Tasks.vue";
import Users from "./views/Users.vue";
import Marketplace from "./views/Marketplace.vue";
import Finance from "./views/Finance.vue";
import B2B from "./views/B2B.vue";
import BusinessTerms from "./views/BusinessTerms.vue";
import Growth2 from "./views/Growth2.vue";
import GrowthYear from "./views/GrowthYear.vue";
import UsersAudit from "./views/UsersAudit.vue";
import News from "./views/News.vue";
import Terms from "./views/Terms.vue";
import Callcentre from "./views/Callcentre.vue";
import CallStats from "./views/CallStats.vue";
import New from "./views/New.vue";
import Article from "./views/Article.vue";
import UsersExport from "./views/UsersExport.vue";
import OrdersAudit from "./views/OrdersAudit.vue";
import Companies from "./views/Companies.vue";
import Company from "./views/Company.vue"
import CompanyJobs from "./views/CompanyJobs.vue"
import CompaniesAudit from "./views/CompaniesAudit.vue";
import Profile from "./views/Profile.vue";
import Skill from "./views/Skill.vue";
import Job from "./views/Job.vue";
import SkillReview from "./views/SkillReview.vue";
import Order from "./views/Order.vue";
import Cart from "./views/Cart.vue";
import Stats from "./views/Stats.vue";
import Jobs from "./views/Jobs.vue";
import Capacity from "./views/Capacity.vue";
import CitySkill from "./views/CitySkill.vue";
import Sms from "./views/Sms.vue";
import BusinessSkills from "./views/BusinessSkills.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      redirect: "/users"
    },
    {
      path: "/users",
      name: "users",
      component: Users
    },
    {
      path: "/notifications",
      name: "notifications",
      component: Notifications
    },
    {
      path: "/campaigns",
      name: "campaigns",
      component: Campaigns
    },
    {
      path: "/campaigns/referral/new",
      name: "createReferralCampaign",
      component: CreateReferralCampaign
    },
    {
      path: "/campaigns/influencer/new",
      name: "createInfluencerCampaign",
      component: CreateInfluencerCampaign
    },
    {
      path: "/finance",
      name: "monthFinances",
      component: Finance
    },
    {
      path: "/marketplace",
      name: "marketplace",
      component: Marketplace
    },
    {
      path: "/growth2",
      name: "growth2",
      component: Growth2
    },
    {
      path: "/growthYear",
      name: "growthYear",
      component: GrowthYear
    },
    {
      path: "/b2b",
      name: "b2b",
      component: B2B
    },
    {
      path: "/users/audit",
      name: "usersAudit",
      component: UsersAudit
    },
    {
      path: "/users/export",
      name: "usersExport",
      component: UsersExport
    },
    {
      path: "/users/:id/skills",
      name: "businessSkills",
      component: BusinessSkills
    },
    {
      path: "/users/:id",
      name: "userProfile",
      component: Profile
    },
    {
      path: "/skills/review",
      name: "skillReview",
      component: SkillReview
    },
    {
      path: "/skills/:id",
      name: "skillPage",
      component: Skill
    },
    {
      path: "/jobs/:id",
      name: "jobPage",
      component: Job
    },
    {
      path: "/news/:id",
      name: "newsPage",
      component: New
    },
    {
      path: "/terms/publish",
      name: "termsPage",
      component: BusinessTerms
    },
    {
      path: "/terms/:id/publish",
      name: "termsVersionPage",
      component: BusinessTerms
    },
    {
      path: "/articles/:id",
      name: "articlePage",
      component: Article
    },
    {
      path: "/skills/:id/:city",
      name: "citySkillPage",
      component: CitySkill
    },
    {
      path: "/companies",
      name: "companies",
      component: Companies
    },
    {
      path: "/companies/audit",
      name: "companiesAudit",
      component: CompaniesAudit
    },
    {
      path: "/companies/:id",
      name: "companyPage",
      component: Company
    },
    {
      path: "/sms",
      name: "smsPage",
      component: Sms
    },
    {
      path: "/companies/:id/jobs",
      name: "companyJobsPage",
      component: CompanyJobs
    },
    {
      path: "/orders",
      name: "orders",
      component: Orders
    },
    {
      path: "/carts",
      name: "carts",
      component: Carts
    },
    {
      path: "/tasks",
      name: "tasks",
      component: Tasks
    },
    {
      path: "/news",
      name: "news",
      component: News
    },
    {
      path: "/terms",
      name: "terms",
      component: Terms
    },
    {
      path: "/orders/audit",
      name: "ordersAudit",
      component: OrdersAudit
    },
    {
      path: "/orders/:id",
      name: "orderPage",
      component: Order
    },
    {
      path: "/carts/:id",
      name: "cartPage",
      component: Cart
    },
    {
      path: "/skills",
      name: "skills",
      component: Stats
    },
    {
      path: "/jobs",
      name: "jobs",
      component: Jobs
    },
    {
      path: "/capacity",
      name: "capacity",
      component: Capacity
    },
    {
      path: "/call",
      name: "call",
      component: Callcentre
    },
    {
      path: "/callstats",
      name: "callstats",
      component: CallStats
    }
  ]
});
